<template>
    <div class="container_self table_parent">
        <h3>系统日志列表</h3>
        <el-row class="search_parent">
            <el-form :model="searchForm" size="mini" label-width="80px" :inline="true">
                <el-form-item label="功能模块">
                    <el-select v-model="searchForm.module" clearable>
                        <el-option v-for="(item,index) in options" :value="item" :label="item" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="执行操作">
                   <el-input v-model="searchForm.type" placeholder="请输入执行操作" clearable></el-input>
                </el-form-item>
                <el-form-item label="开始时间">
                    <el-date-picker
                            v-model="searchForm.startTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            clearable
                            placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间">
                    <el-date-picker
                            v-model="searchForm.endTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            clearable
                            placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-table :data="consoleList" v-loading="loading">
            <el-table-column label="ID" prop="id" align="center" width="100"></el-table-column>
            <el-table-column label="系统模块" prop="module" align="center"></el-table-column>
            <el-table-column label="执行操作" prop="type" align="center"></el-table-column>
            <el-table-column label="操作人员ID" prop="userId" align="center"  width="100"></el-table-column>
            <el-table-column label="操作人员" prop="username" align="center"></el-table-column>
            <el-table-column label="操作使用ip" prop="ip" align="center"></el-table-column>
            <el-table-column label="操作时间" prop="createTime" align="center"></el-table-column>
        </el-table>

        <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchForm.currentPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="searchForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
        </el-pagination>
    </div>
</template>


<script>
import {axiosGet,axiosPost} from '@/assets/ajaxFn'
export default {
    data(){
        return{
            searchForm:{
                module:'',
                endTime:"",
                startTime:"",
                pageSize:20,
                currentPage:1,
                type:""
            },
            consoleList:[],
            loading:false,
            total:0,
            options:["广告管理", "APP渠道管理", "APP管理", "客户管理", "域名管理", "事件管理", "GAM账号管理", "GAM报告", "GAM汇总", "IP风险管理", "视频分类管理", "视频管理", "升级包管理", "登录后台", "权限管理", "个人信息", "角色管理", "运营人员联系方式管理", "系统日志管理", "用户管理"]
        }
    },
    methods:{
        onSubmit(){
            this.searchForm.currentPage=1;
            this.getList(this.searchForm);
        },
        handleSizeChange(val){
            this.searchForm.pageSize=val;
            this.searchForm.currentPage=1;
            this.getList(this.searchForm);
        },
        handleCurrentChange(val){
            this.searchForm.currentPage=val;
            this.getList(this.searchForm);
        },
       async getList(params){
            this.loading=true;
           await axiosGet('/api/system/log/list',params).then(res=>{
                if(res.code==0){
                    this.consoleList=res.data.records;
                    this.total=res.data.total;
                }
            });
            this.loading=false;
        }
    },
    mounted(){
        this.getList(this.searchForm);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/view/systemConsole.vue